import Vue from 'vue'
import moment from 'moment-timezone'
import 'moment/dist/locale/de' 

Vue.prototype.$defaultTimezone = 'Europe/Berlin'
moment.tz.setDefault(Vue.prototype.$defaultTimezone)
moment.locale('de')

export default moment